'use client'

import _ from 'lodash'
import {FC} from 'react'

import {ProfileBio} from '@/components/about-us/profile/ProfileBio'
import {ProfileBlogs} from '@/components/about-us/profile/ProfileBlogs'
import {ProfileHero} from '@/components/about-us/profile/ProfileHero'
import {TeamNavigation} from '@/components/about-us/profile/TeamNavigation'
import {Section} from '@/components/common/content/Section'
import {Page} from '@/components/Page'
import {getAboutUsContent} from '@/content/aboutUs'
import {TeamMemberType} from '@/content/team'
import {BlogOverview} from '@/utils/contentful'

type AboutUsProfilePageProps = {
  teamMember: TeamMemberType
  blogsByAuthor: BlogOverview[]
}

const AboutUsProfilePage: FC<React.PropsWithChildren<AboutUsProfilePageProps>> = ({
  teamMember,
  blogsByAuthor,
}) => {
  const {navigation} = getAboutUsContent().profilePage
  const {name, bio, education, licenses} = teamMember

  const teamInNavigation = _.take(
    navigation.teamMembers.filter((member) => member.name !== name),
    3,
  )

  return (
    <>
      <Page>
        <Section hasPaddingTop hasPaddingBottom>
          <ProfileHero teamMember={teamMember} />
        </Section>
        {bio && education && (
          <Section hasPaddingBottom>
            <ProfileBio bio={bio} education={education} licenses={licenses} />
          </Section>
        )}
        {blogsByAuthor.length > 0 && (
          <Section hasPaddingBottom>
            <ProfileBlogs blogs={blogsByAuthor} />
          </Section>
        )}
        <Section hasPaddingBottom isHighlighted>
          <TeamNavigation team={teamInNavigation} />
        </Section>
      </Page>
    </>
  )
}

export default AboutUsProfilePage
